/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { SurveyStats } from '@g17eco/types/initiativeStats';
import { roundTo } from '@utils/number';

// Convert to percentage
export function toPercentageProgress(status: SurveyStats['status']): SurveyStats['status'] {
  const total = status.created + status.updated + status.rejected + status.verified;
  if (total === 0) {
    return status;
  }

  return {
    created: roundTo((status.created / total) * 100),
    updated: roundTo((status.updated / total) * 100),
    rejected: roundTo((status.rejected / total) * 100),
    verified: roundTo((status.verified / total) * 100),
  };
}
